import martinKucera2025cropped from "@assets/images/members/kucera-martin-2025-cropped.jpg?w=250&webp&imagetools";
import romanSvejda from "@assets/images/members/roman-svejda-cropped.jpg?w=250&webp&imagetools";
import type { ContactPerson } from "@components/ContactPerson.js";
import type { Tenant } from "@core/schema/Tenant.js";

export enum BookMeetingPerson {
	Kucera = "Kucera",
	Svejda = "Svejda",
}

export function getBookMeetingPeople(tenant: Tenant): Record<BookMeetingPerson, ContactPerson> {
	return {
		[BookMeetingPerson.Kucera]: {
			name: "Martin Kučera",
			role: "CEO",
			phone: "+420 773 050 550",
			email: "kucera@fastest.cz",
			linkedin: "kucera-martin",
			photo: martinKucera2025cropped,
			show: true,
		},
		[BookMeetingPerson.Svejda]: {
			name: "Roman Švejda",
			role: "Delivery Manager",
			phone: "+420 773 108 020",
			email: "roman.svejda@fastest.cz",
			photo: romanSvejda,
			linkedin: "roman-svejda",
			show: true,
		},
	};
}
